
/* injects from baggage-loader */

angular.module('siter.io').factory('LmsPage', [
  "Restangular", "$rootScope", "$stateParams", "$state", "$modal", "$injector",
  (Restangular, $rootScope, $stateParams, $state, $modal, $injector) => {
    return {
      _currentSite: Restangular.one('lms_pages', $stateParams.lessonId),
      get: (id) => {
        if (id) {
          return Restangular.one('lms_pages', id).get();
        } else {
          return Restangular.one('lms_pages', $stateParams.lessonId).get();
        }
      },
      getList: () => {
        return Restangular.all('lms_pages').getList();
      },
      update: (site) => {
        return Restangular.all('lms_pages').one(site.id).customPUT(site);
      },
      updateByRoute: (site) => {
        return Restangular.all('lms_pages').one($stateParams.lessonId).customPUT(site);
      },
      remove: (id) => {
        return Restangular.one('lms_pages', id).remove();
      },
      create: (site) => {
        return Restangular.all('lms_pages').post(site);
      },
      saveIndex: (changes) => {
        return Restangular.one('lms_pages', $stateParams.lessonId).all('assets/save').post({
          changes: changes,
          path: $rootScope.currentFile.full_path
        });
      },
      transfer: (data) => {
        return Restangular.one('lms_pages', $stateParams.lessonId).all("transfer").post(data);
      },
      share: (site) => {
        return Restangular.one('lms_pages', $stateParams.lessonId).all("share").post(site);
      },
      setTemplate: (template_id) => {
        return Restangular.all("lms_pages").one($state.params.lessonId).customPUT({
          template_id: template_id
        });
      },
      addSite: () => {
        return $state.go("root.new_site");
      },
      clearFonts: () => {
        return Restangular.all("lms_pages").one($state.params.lessonId).all("clear_fonts").post();
      },
      createTemplate: (templateParams) => {
        return Restangular.all("lms_pages").one($state.params.lessonId).all("templates").post(templateParams);
      },
      publish: () => {
        return Restangular.all("lms_pages").one($state.params.lessonId).all("build").post();
      },
      clone: (site_id) => {
        return Restangular.all("lms_pages").one(site_id).all("clone").post();
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/site/lesson.service.js